var dataTypes = {
    simpleComparisons: [
        'string',
        'text',
        'richtext',
        'boolean',
        'pointer',
        'url',
        'image',
        'integer',
        'float',
        'number',
        'time',
        'timestamp',
        'location',
    ],
    complexComparisons: [
        'integer',
        'float',
        'number',
        'time',
        'timestamp',
        'location',
        'string',
        'text',
        'richtext',
    ],
};
export var FilterTypes = [
    {
        name: 'Equals',
        operation: 'eq',
        accepts: dataTypes.simpleComparisons,
    },
    {
        name: 'Not Equals',
        operation: 'neq',
        accepts: dataTypes.simpleComparisons,
    },
    {
        name: 'Greater than',
        operation: 'gt',
        accepts: dataTypes.complexComparisons,
    },
    {
        name: 'Greater than or equals',
        operation: 'gte',
        accepts: dataTypes.complexComparisons,
    },
    {
        name: 'Less than',
        operation: 'lt',
        accepts: dataTypes.complexComparisons,
    },
    {
        name: 'Less than or equals',
        operation: 'lte',
        accepts: dataTypes.complexComparisons,
    },
    {
        name: 'Like',
        operation: 'like',
        accepts: dataTypes.simpleComparisons,
    },
    {
        name: 'Not Like',
        operation: 'notlike',
        accepts: dataTypes.simpleComparisons,
    },
    {
        name: 'Null',
        operation: 'null',
        accepts: dataTypes.simpleComparisons,
    },
    {
        name: 'Not Null',
        operation: 'nnull',
        accepts: dataTypes.simpleComparisons,
    },
];
